import TPEAction from "../common/TPEAction";

export default class DashboardAction extends TPEAction {
    // Add any Dashboard action specific properties here
}